import {
  DialogContent as MuiDialogContent,
  IconButton as MuiIconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const CloseButton = styled(MuiIconButton)(() => ({
  position: 'absolute',
  right: 8,
  top: 8,
  borderRadius: '50%',
  zIndex: 1,
}));

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    overflow: 'visible',
  },
  [theme.breakpoints.down('sm')]: {
    height: '100%',
  },
}));
